"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var React = _interopRequireWildcard(require("react"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function SvgCamera(props, svgRef) {
  return (0, _jsxRuntime.jsxs)("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), {}, {
    children: [(0, _jsxRuntime.jsx)("defs", {
      children: (0, _jsxRuntime.jsx)("path", {
        id: "camera_svg__a",
        d: "M23.466 9.951h-1.365l-.341-1.095c-.454-1.316-1.669-2.195-3.03-2.19h-5.46c-1.375.003-2.595.907-3.03 2.245l-.341 1.095H8.533c-1.767 0-3.2 1.47-3.2 3.284v8.759c0 1.814 1.433 3.284 3.2 3.284h14.933c1.768 0 3.2-1.47 3.2-3.284V13.29a3.328 3.328 0 00-.918-2.358 3.16 3.16 0 00-2.282-.98zm1.067 12.043c0 .605-.478 1.095-1.067 1.095H8.533c-.589 0-1.066-.49-1.066-1.095v-8.758c0-.605.477-1.095 1.066-1.095h2.134c.478.025.914-.279 1.066-.745l.576-1.795a1.07 1.07 0 011.014-.745h5.46c.46 0 .867.299 1.014.745l.576 1.795c.14.428.521.723.96.745h2.133c.59 0 1.067.49 1.067 1.095v8.758zM16 12.141c-2.357 0-4.267 1.96-4.267 4.38 0 2.418 1.91 4.378 4.267 4.378 2.356 0 4.266-1.96 4.266-4.379 0-1.161-.45-2.275-1.25-3.097A4.215 4.215 0 0016 12.141zm0 6.569c-1.178 0-2.134-.98-2.134-2.19s.956-2.19 2.134-2.19 2.133.98 2.133 2.19-.955 2.19-2.133 2.19z"
      })
    }), (0, _jsxRuntime.jsxs)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [(0, _jsxRuntime.jsx)("mask", {
        id: "camera_svg__b",
        fill: "currentColor",
        children: (0, _jsxRuntime.jsx)("use", {
          xlinkHref: "#camera_svg__a"
        })
      }), (0, _jsxRuntime.jsx)("use", {
        fill: "currentColor",
        fillRule: "nonzero",
        xlinkHref: "#camera_svg__a"
      }), (0, _jsxRuntime.jsx)("path", {
        fill: "currentColor",
        d: "M0 0h32v32H0z",
        mask: "url(#camera_svg__b)"
      })]
    })]
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
var _default = ForwardRef;
exports["default"] = _default;
//# sourceMappingURL=Camera.js.map